/**
 * Tracking y checkout centralizados.
 *
 * 1. Pegá el link real de tu checkout en CHECKOUT_URL (Mercado Pago, Hotmart, etc.).
 *    Mientras esté vacío, todos los CTA hacen scroll a la sección de oferta (#oferta).
 * 2. Instalá el código base de Meta Pixel y/o Google Analytics (gtag.js) con tus IDs reales.
 *    Este archivo NO incluye scripts ni IDs: solo dispara eventos si window.fbq / window.gtag existen.
 * 3. Todos los botones de compra comparten la clase "cta-checkout" y el atributo
 *    data-cta-location="<ubicación>" para segmentar en reportes.
 * 4. El evento Purchase debe dispararse en la página de gracias llamando a trackPurchase().
 */

export const CHECKOUT_URL = 'https://viandas-express-15.impultienda.ar/checkout';

type TrackFn = (...args: unknown[]) => void;

declare global {
  interface Window {
    fbq?: TrackFn;
    gtag?: TrackFn;
    dataLayer?: Record<string, unknown>[];
  }
}

type EventName = 'ViewContent' | 'InitiateCheckout' | 'Purchase';

const GA_EVENT_NAMES: Record<EventName, string> = {
  ViewContent: 'view_item',
  InitiateCheckout: 'begin_checkout',
  Purchase: 'purchase',
};

export const PRODUCT_PARAMS = {
  content_name: '30 Días de Viandas Resueltas',
  content_ids: ['30-dias-viandas-resueltas'],
  content_type: 'product',
  value: 16990,
  currency: 'ARS',
};

export function trackEvent(name: EventName, params: Record<string, unknown> = {}) {
  if (typeof window === 'undefined') return;
  window.fbq?.('track', name, params);
  window.gtag?.('event', GA_EVENT_NAMES[name], params);
  window.dataLayer?.push({ event: name, ...params });
}

export function goToCheckout(location: string) {
  trackEvent('InitiateCheckout', { ...PRODUCT_PARAMS, cta_location: location });
  if (CHECKOUT_URL) {
    window.location.href = CHECKOUT_URL;
    return;
  }
  document.getElementById('oferta')?.scrollIntoView({ behavior: 'smooth', block: 'start' });
}

/** Llamar en la página de gracias, una vez confirmado el pago. */
export function trackPurchase(transactionId?: string) {
  trackEvent('Purchase', { ...PRODUCT_PARAMS, transaction_id: transactionId });
}
